import actions from './actions';
import getters from './getters';
import mutations from './mutations';
var state = () => ({
  total: 0,
  items: [],
  success: false,
  successServer: true,
  cartState: 'LOADING'
});
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};